import React, { useState } from "react";
import Papa from "papaparse";
import { useEffect } from "react";
import { collection, doc, setDoc } from "firebase/firestore";
import { db } from "../firebase-config";

export default function CsvUploader({ allEducationCenters, fetchInvoicesPending }) {
    const [data, setData] = useState([]);
    const [summary, setSummary] = useState([]);

    const [unmatchedCenters, setUnmatchedCenters] = useState([])
    const [matchedCenters, setMatchedCenters] = useState([])

    useEffect(() => {
        if (summary.length > 0) {
            updateCentersPendingAmounts()
        }
    }, [summary])


    const updateCentersPendingAmounts = async () => {
        let unmatchedCentersLoc = [], matchedCentersLoc = []
        for (let row of summary) {
            const matchingCenter = allEducationCenters.find(r => (r.invoiceName || r.name) === row.center)
            if (matchingCenter) {
                matchedCentersLoc.push(row)
            } else {
                unmatchedCentersLoc.push(row)
            }
        }
        setUnmatchedCenters(unmatchedCentersLoc)
        setMatchedCenters(matchedCentersLoc)


        // for (let row of summary) {
        //     await addDoc(collection(db, 'events'), {

        //     })
        // }

        await setDoc(doc(db, 'xero-invoices-pending-centers', 'xero-invoices-pending-centers'), {
            records: summary,
            created: new Date().toISOString()
        })

        fetchInvoicesPending()
    }

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (result) => {
                setData(result.data);

                // Aggregate pending amounts per center
                const centerTotals = {};
                result.data.forEach((row) => {
                    if (row.Status === "Awaiting Payment") {
                        const center = row.ContactName;
                        const amount = parseFloat(row.InvoiceAmountDue || 0);
                        const dueDate = row.DueDate;
                        const InvoiceNumber = row.InvoiceNumber;

                        if (!centerTotals[center]) {
                            centerTotals[center] = { total: 0, dues: [] };
                        }
                        if (!centerTotals[center].dues.find(r => r.InvoiceNumber === InvoiceNumber)) {
                            centerTotals[center].total += amount;
                            centerTotals[center].dues.push({ amount, dueDate, InvoiceNumber });
                        }
                    }
                });

                // Convert to array for easy rendering
                const summaryArray = Object.entries(centerTotals).map(
                    ([center, { total, dues }]) => ({
                        center,
                        total,
                        dues,
                    })
                );

                setSummary(summaryArray);
            },
        });
    };

    return (
        <div className="p-4">
            <input type="file" accept=".csv" onChange={handleFileUpload} />
            <div style={{ display: 'flex', width: '100%' }}>
                <div style={{ width: '50%' }}>
                    <h2 className="text-lg font-bold mt-4">Unmatched Centers ({unmatchedCenters.length})</h2>

                    <ul>
                        {unmatchedCenters.map((item, idx) => (
                            <li key={idx} className="mb-3">
                                <p>
                                    <strong>{item.center}</strong> — Total Pending:{" "}
                                    {item.total.toFixed(2)}
                                </p>
                                <ul className="ml-4 list-disc">
                                    {item.dues.map((d, i) => (
                                        <li key={i}>
                                            Amount: {d.amount}, Due: {d.dueDate}, InvoiceNumber: {d.InvoiceNumber}
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                    </ul>
                </div>

                <div style={{ width: '50%' }}>
                    <h2 className="text-lg font-bold mt-4">Matched Centers({matchedCenters.length})</h2>
                    <ul>
                        {matchedCenters.map((item, idx) => (
                            <li key={idx} className="mb-3">
                                <p>
                                    <strong>{item.center}</strong> — Total Pending:{" "}
                                    {item.total.toFixed(2)}
                                </p>
                                <ul className="ml-4 list-disc">
                                    {item.dues.map((d, i) => (
                                        <li key={i}>
                                            Amount: {d.amount}, Due: {d.dueDate}, InvoiceNumber: {d.InvoiceNumber}
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
